module.exports = __webpack_public_path__ + "media/images/success-stories-6-4e541242061d007db686b2eec7c22cf2.jpeg";